export const getPodToggleStateAfterCustomPeerAdded = prevState => ({
  ...prevState,
  podCompare1: true,
  podCompare2: true,
  podCompare3: true,
})
